var React = require('react');

function IconStasis (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z","fill":"#004F87","key":0}),React.createElement("path",{"d":"M23.8322 67.4154L50.1735 80.2852L81.0479 65.2078V57.5318L58.3446 38.537L39.206 54.5521L35.4715 51.4286L40.5584 47.175L37.0529 44.2433L19.2994 59.0981V65.2057L23.8322 67.4154ZM85.8379 30.5512V68.192L50.1735 85.6097L14.5049 68.192V30.5512L50.1735 13.1313L85.8379 30.5512ZM81.0391 51.2868V33.5418L50.1647 18.4646L19.2906 33.5418V52.8529L37.0444 37.9982L44.2841 44.0535L58.3361 32.2919L81.0391 51.2868Z","fill":"white","key":1})]);
}

IconStasis.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = IconStasis;

IconStasis.default = IconStasis;
